var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMapArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2565_93903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.0005 42.28C48.0005 42.44 47.9606 42.6 47.9006 42.76C47.8405 42.92 47.7605 43.04 47.6405 43.16L42.6605 48.14C42.5405 48.24 42.4205 48.34 42.2605 48.4C42.1205 48.46 41.9405 48.5 41.7805 48.5C41.6205 48.5 41.4605 48.46 41.3205 48.4C41.1605 48.34 41.0205 48.24 40.9006 48.14L33.2805 40.5L29.1605 46.7C29.0205 46.9 28.8405 47.06 28.6205 47.14C28.4005 47.24 28.1605 47.28 27.9405 47.24C27.7005 47.2 27.4805 47.1 27.3005 46.96C27.1205 46.8 27.0005 46.6 26.9205 46.36L19.4805 21.52C19.4005 21.3 19.4005 21.08 19.4605 20.86C19.5205 20.64 19.6205 20.44 19.7805 20.28C19.9405 20.12 20.1405 20.02 20.3605 19.96C20.5805 19.9 20.8005 19.9 21.0205 19.98L45.8805 27.42C46.1005 27.5 46.3005 27.62 46.4605 27.8C46.6005 27.98 46.7005 28.2 46.7405 28.44C46.7805 28.66 46.7405 28.9 46.6605 29.12C46.5605 29.34 46.4005 29.52 46.2005 29.66L40.0005 33.78L47.6405 41.4C47.7605 41.52 47.8405 41.66 47.9006 41.8C47.9606 41.96 48.0005 42.12 48.0005 42.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0405 39.42C16.2605 39.42 11.7605 37.56 8.36055 34.18L10.1205 32.42C13.0405 35.34 16.9205 36.94 21.0405 36.94V39.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.10055 31.46C4.78055 29.48 3.86055 27.32 3.40055 25L5.84055 24.52C6.24055 26.52 7.02055 28.4 8.16055 30.08L6.10055 31.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.40055 21.48H3.06055C3.06055 16.68 4.92055 12.18 8.28055 8.78L10.0405 10.54C7.14055 13.46 5.54055 17.34 5.54055 21.46H3.40055V21.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2005 18.38C35.8005 16.38 35.0205 14.52 33.8605 12.82L35.9205 11.44C37.2405 13.4 38.1605 15.58 38.6205 17.9L36.1805 18.4L36.2005 18.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9205 10.48C29.0005 7.58 25.1205 5.98 21.0205 5.98L20.9805 3.88V3.5C25.8005 3.5 30.2805 5.36 33.6805 8.72L31.9205 10.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4005 8.62L11.0205 6.56C12.9805 5.24 15.1605 4.32 17.4805 3.86L17.9605 6.3C15.9605 6.7 14.0805 7.48 12.4005 8.62Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2565_93903"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMapArrow);
export default __webpack_public_path__ + "static/media/ic-map-arrow.5f7dff29cce86cc3d9f91f0f0c380008.svg";
export { ForwardRef as ReactComponent };